import fetchPlus from '../lib/fetchPlus/fetchPlus';
import type { ApiResponse } from '../types/API/ApiResponse';
import type NotificationSettings from '../types/API/user/notifications/settings/NotificationSettings';
import type NotificationSettingsSites from '../types/API/user/notifications/settings/NotificationSettingsSites';
import type UpdatedNotificationSettings from '../types/API/user/notifications/settings/UpdatedNotificationSettings';
import type UpdatedProfile from '../types/API/user/UpdatedProfile';
import type User from '../types/API/user/User';
import type { HubConfig } from '../types/API/user/User';

const updateNotificationSettings = (updatedSettings: UpdatedNotificationSettings) =>
    fetchPlus<ApiResponse<'data', NotificationSettings>>(
        `${process.env.NEXT_PUBLIC_AUTH_API}/auth/me/notifications`,
        'PATCH',
        updatedSettings,
    );

const getNotificationSettings = () =>
    fetchPlus<ApiResponse<'data', NotificationSettings>>(
        `${process.env.NEXT_PUBLIC_AUTH_API}/auth/me/notifications`,
        'GET',
    );

const getNotificationSettingsSites = () =>
    fetchPlus<ApiResponse<'data', NotificationSettingsSites>>(
        `${process.env.NEXT_PUBLIC_AUTH_API}/auth/me/notifications/sites`,
        'GET',
    );

const updateProfile = (profile: UpdatedProfile) =>
    fetchPlus<ApiResponse<'data', User>>(`${process.env.NEXT_PUBLIC_AUTH_API}/auth/me`, 'PATCH', profile);

const updateUserConfig = (preferences: HubConfig) =>
    fetchPlus<ApiResponse<'data', User>>(`${process.env.NEXT_PUBLIC_AUTH_API}/auth/me/config`, 'PATCH', {
        config: {
            hub: preferences,
        },
    });

const userService = {
    updateNotificationSettings,
    getNotificationSettings,
    getNotificationSettingsSites,
    updateProfile,
    updateUserConfig,
};

export default userService;
